import { SvgIcon } from "@/components/icon"
import { CarouselRef } from "antd/es/carousel"
import { FC } from "react"
import "./SliderButtons.less"

type SliderButtonsProps = {
  slider: React.RefObject<CarouselRef | null>
}

const SliderButtons: FC<SliderButtonsProps> = ({ slider }) => {
  const onNext = () => {
    slider?.current?.next()
  }
  const onPrev = () => {
    slider?.current?.prev()
  }

  return (
    <div className={"slider-buttons"}>
      <div className={"slider-button"} onClick={onPrev}>
        <SvgIcon type={"website-slider-hex-button"} className={"button-svg-image"} />
        <SvgIcon type={"website-slider-arrow-left"} />
      </div>

      <div className={"slider-button"} onClick={onNext}>
        <SvgIcon type={"website-slider-hex-button"} className={"button-svg-image"} />
        <SvgIcon type={"website-slider-arrow-right"} />
      </div>
    </div>
  )
}

export default SliderButtons
